import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, message, Row, Space, Statistic, Table, Tag, Typography } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { get } from "../../utils/http";

const { Title } = Typography;

interface SalesItem {
  product_type: "module_unlock" | "all_access";
  module_id: number | null;
  product_name: string;
  sales_count: number;
  sales_amount_cents: number;
  last_paid_at?: string | null;
}

interface SalesStatistics {
  items: SalesItem[];
  total_sales_count: number;
  total_sales_amount_cents: number;
}

const yuan = (cents: number) => `¥${(Number(cents || 0) / 100).toFixed(2)}`;

export default function PaymentStatisticsPage() {
  const [loading, setLoading] = useState(false);
  const [statistics, setStatistics] = useState<SalesStatistics>({
    items: [],
    total_sales_count: 0,
    total_sales_amount_cents: 0,
  });

  const fetchStatistics = useCallback(async () => {
    setLoading(true);
    try {
      const response = await get("/api/manage/payment-sales-statistics");
      if (response.data.code === 0) {
        setStatistics(response.data.data);
      }
    } catch (error) {
      message.error("获取支付统计失败");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatistics();
  }, [fetchStatistics]);

  return (
    <div style={{ padding: 24, background: "#f5f5f5", minHeight: "100%" }}>
      <Card
        title={<Title level={3} style={{ margin: 0 }}>支付统计</Title>}
        extra={<Button icon={<ReloadOutlined />} onClick={fetchStatistics} loading={loading}>刷新</Button>}
      >
        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
          <Col xs={24} md={12}>
            <Card size="small"><Statistic title="总销量" value={statistics.total_sales_count} suffix="单" /></Card>
          </Col>
          <Col xs={24} md={12}>
            <Card size="small"><Statistic title="总销售额" value={yuan(statistics.total_sales_amount_cents)} /></Card>
          </Col>
        </Row>

        <Title level={5}>各永久解锁商品销量</Title>
        <Table<SalesItem>
          rowKey={item => `${item.product_type}-${item.module_id ?? "all"}`}
          loading={loading}
          dataSource={statistics.items}
          pagination={false}
          columns={[
            {
              title: "商品",
              dataIndex: "product_name",
              render: (value, record) => (
                <Space>
                  <span>{value}</span>
                  {record.product_type === "all_access" ? <Tag color="purple">全站</Tag> : <Tag>模块</Tag>}
                </Space>
              ),
            },
            { title: "销量", dataIndex: "sales_count", width: 140, render: value => `${value} 单` },
            { title: "销售额", dataIndex: "sales_amount_cents", width: 180, render: yuan },
            {
              title: "最近支付时间",
              dataIndex: "last_paid_at",
              width: 220,
              render: value => value ? new Date(value).toLocaleString() : "-",
            },
          ]}
        />
      </Card>
    </div>
  );
}
